<form [formGroup]="registrationFormGroup" *ngIf="registrationFormGroup" class="registrationForm">
    <div class="formgrid grid">
        <div class="field col-12 md:col-12 lg:col-12 titleField">
            <label i18n="@@appointment-registration-form.field.name">Name</label>
            <div>
                <input type="text" pInputText formControlName="name" class="w-full" />
            </div>

        </div>
        <div class="field col-12 md:col-6 lg:col-6 headerField">
            <label i18n="@@appointment-registration-form.field.header">Header</label>
            <editor formControlName="header" [init]="{
            base_url: baseHref + 'assets/tinymce',
            branding: false,
            height: 200,
            menubar: false,
            plugins: 'code',
            forced_root_block : 'div',
            statusbar: false,
            toolbar:
                'code | bold italic | backcolor forecolor | removeformat'
        }"></editor>
        </div>
        <div class="field col-12 md:col-6 lg:col-6 footerField">
            <label i18n="@@appointment-registration-form.field.footer">Footer</label>
            <editor formControlName="footer" class="editor" [init]="{
            base_url: baseHref + 'assets/tinymce',
            branding: false,
            height: 200,
            menubar: false,
            plugins: 'code',
            forced_root_block : 'div',
            statusbar: false,
            toolbar:
                'code | bold italic | backcolor forecolor | removeformat'
        }"></editor>
        </div>
        <div class="col-12">
            <div class="flex mt-2 align-items-center addFields">
                <div>
                    <p-button icon="far fa-plus" styleClass="p-button-sm m-0" class="addButton" (onClick)="onCreateField()"
                    i18n-label="@@appointment-configuration.registration-forms.new-field" severity="secondary"></p-button>
                </div>

                <div class="ml-3">
                    <label i18n="@@appointment-registration-form.field.fields mt-3">Fields</label>
                    <div *ngIf="fields.length ==0" i18n="@@appointment-registration-form.field.fields.empty" class="text-sm emptyMessage">* No fields created
                    yet.</div>
                </div>
            
            </div>

            <div formArrayName="fields" class="mt-3 formFields">
                <div *ngFor="let field of fields.controls; let i = index" [formGroupName]="i"
                    class="mt-2 flex flex-wrap">
                    <!-- <div class="font-bold text-lg align-self-center col-fixed" style="width: 20px;">
                        {{i+1}}
                    </div> -->
                    <div class="field col-12 md:col-7 p-0 fieldName">
                        <label i18n="@@appointment-registration-form.field.columName">Name</label>
                        <div>
                            <input type="text" pInputText formControlName="columnName" class="w-full" />
                        </div>
                    </div>
                    <div class="col-12 md:col-5 p-0 flex justify-content-between md:pl-2">
                        <div style="width: 33%;" class="field fieldType">
                            <label i18n="@@appointment-registration-form.field.type">Field type</label>
                            <div>
                                <p-dropdown [options]="columnTypes" formControlName="type" optionValue="value"
                                    appendTo="body" [style]="{'width':'100%'}" [autoDisplayFirst]="false"
                                    [readonly]="field.get('propertyName').value != null && usedInEvents"
                                    optionLabel="label"></p-dropdown>
                            </div>                        
                        </div>
                        <div style="width: 33%;" class="flex flex-column align-items-center field fieldRequired">
                            <label i18n="@@appointment-registration-form.field.reuqired" class="mb-2">Required</label>
                            <div class="mt-2">
                                <p-checkbox formControlName="mandatory" [binary]="true"></p-checkbox>
                            </div>
                        </div>
                        <div style="width: 33%;" class="flex flex-row justify-content-around align-items-center">
                            <div class="field flex flex-column align-items-center justify-content-center mr-2 fieldSequence">
                                    <label i18n="@@appointment-registration-form.field.sequence">Sequence</label>
                                    <div class="flex">
                                        <p-button [text]="true" icon="far fa-chevron-up" [disabled]="!(i<fields.controls.length && i!=0)"
                                            styleClass="ml-1 mt-1" (onClick)="onSwapFields(i,i-1)" class="upButton"></p-button>
                                        <p-button [text]="true" icon="far fa-chevron-down" [disabled]="!(i+1<fields.controls.length)"
                                            styleClass="ml-1 mt-1" (onClick)="onSwapFields(i,i+1)" class="downButton"></p-button>
                                    </div>
                                </div>
        
                                <p-button icon="far fa-trash" [text]="true" severity="danger" styleClass="ml-1 mt-1" class="removeButton"
                                    (onClick)="onRemoveField(i)"></p-button>
        
                                <p-button icon="far fa-copy" [text]="true" severity="secondary" styleClass="ml-1 mt-1" class="copyButton" *ngIf="field.get('propertyName').value"
                                    (onClick)="copyToClipboard(field.get('propertyName').value)"></p-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="usedInEvents" i18n="@@appointment-registration-form.field.isUsed"
        class="text-sm mt-2 mb-4 p-message p-message-info p-4 inUseHintText">
        This form is already in use. Fields that are already Already saved can no longer be
        adjusted.
    </div>

    <div *ngIf="hasEnumField()" i18n="@@appointment-registration-form.field.enum-type-info" class="text-sm mt-2 mb-4 p-message p-message-info p-4 enumerationHintText">Enumerations (dropdowns) can only be added by our customer support. Please contact us if you require this data type.</div>
    <div class="text-right">
        <p-button label="Save" styleClass="mt-3 mb-3" class="saveButton" (onClick)="onSave()"
            i18n-label="@@appointment-configuration.registration-forms.save" severity="secondary"></p-button>
    </div>
</form>